/**
 * `Idempotency-Key` header generator. The backend's `@Idempotent()`
 * decorator (EBT/9 §"Idempotency") requires this header on every POST
 * that mutates state — swallowed double-submits, refresh storms, etc.
 *
 * The shape is opaque to the server so any unique-per-request string
 * works. We use `crypto.randomUUID()` when available (modern browsers
 * + Node ≥18) with a fallback for older environments.
 */
export function makeIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback: timestamp + random hex. Not cryptographically strong,
  // but satisfies "unique per request" for legacy fallbacks.
  return `ebt-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
